import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { PendingOrdersInfo } from '../../../../server-types';
import { CardPlaceholder, FancyCard } from '../style';
import { PendingOrdersIcon, Typography } from '../../../../ui-kit';
import { routePaths } from '../../../../routePaths';

const PendingOrdersView: React.FC<PendingOrdersInfo> = ({ orderQuantity, pendingTotalPrice }) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const history = useHistory();

    const handleNavigateToPendingOrders = () => {
        const searchParamString = new URLSearchParams({ open: '1' }).toString();
        const path = `${routePaths.orders}?${searchParamString}`;
        history.push(path);
    };

    return (
        <>
            <FancyCard solidFill onClick={handleNavigateToPendingOrders}>
                <Box
                    justifySelf='flex-start'
                    display='flex'
                    flexGrow={1}
                    alignItems='center'
                >
                    <Box fontSize={80} display='flex' alignContent='center'>
                        <PendingOrdersIcon fontSize='inherit' height={80} />
                    </Box>
                    <CardPlaceholder>{orderQuantity}</CardPlaceholder>
                </Box>
            </FancyCard>
            <Typography variant="body2">{`${t('Pend. income:')} ${priceService.toLocaleString(pendingTotalPrice)}`}</Typography>
        </>
    );
};

export default PendingOrdersView;
